import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { I18n } from 'react-i18next'
import i18n from '../config/i18n'
import Store from 'store'
import regions from '../config/regions.json'
import AluKHeader from './AluKHeader'
import './HandlePicker.css'
import './Configurator.css'

class HandlePicker extends Component {
  constructor (props) {
    super(props)

    // Init from parent
    this.handles = props.handles
    this.region = props.region

    // Or standalone call (first step before configurator)
    if (typeof props.match !== 'undefined') {
      // Init i18n
      const region = props.match.params.region
      this.region = region

      let lang

      regions.forEach((continent) => {
        const r = continent.countries.find((c) => c.id === region)
        if (typeof r !== 'undefined') {
          lang = r.lang
          this.handles = require('../config/handles/' + r.colorSet + '.json')
        }
      })

      i18n.changeLanguage(lang)
    }

    this.state = {
      handle: null,
      frame: Store.get('backgroundFrame') || 0
    }
  }

  setFrameColor (frame) {
    this.setState({ frame: frame }, () => {
      Store.set('backgroundFrame', frame)
      if (typeof this.props.onUpdate === 'function') {
        this.props.onUpdate()
      }
    })
  }

  render () {
    let handleComps = []
    this.handles.forEach((h, i) => {
      const thumb = require('../assets/images/thumbs/handles/' + h.handle + '.png')
      const classes = ['aluk-activable']

      if (this.props.handle === h.handle) classes.push('active')

      // I know that's horrible
      if (['H48103', 'H48104'].includes(h.handle)) classes.push('declinable')

      handleComps.push(
        <span key={h.handle} className={classes.join(' ')}>
          <Link
            to={'/' + this.region + '/' + h.handle}
            className={'configurator-handle-link'}
          ><img src={thumb} alt={h.handle} /></Link>
        </span>
      )
    })

    let frameClasses = ['configurator-frames']
    let frameComps = []
    // Getting the first element as every handle has the same color collection
    // ... for now :')
    this.handles[0].backgroundFrames.forEach((f, i) => {
      let classes = ['aluk-activable', 'configurator-color-picker']

      if (this.state.frame === i) {
        classes.push('active')
      }

      frameComps.push(
        <a key={i}
          className={classes.join(' ')}
          onClick={() => this.setFrameColor(i)}
          style={{ background: f.css }}
        >
          <span>
            {'RAL ' + f.ral}
          </span>
        </a>
      )
    })

    return [
      <AluKHeader key='aluk-header' />,
      <I18n key='aluk-step2'>
        {(t, { i18n }) => (
          <div className='configurator-handles-wrapper'>
            <div className={frameClasses.join(' ')}>
              <h4>{t('configurator.chooseFrameColor')}</h4>
              {frameComps}
            </div>
            <div className='configurator-handles'>
              <h4>{t('configurator.chooseHandle')}</h4>
              {handleComps}
            </div>
          </div>
        )}
      </I18n>
    ]
  }
}

export default HandlePicker



// WEBPACK FOOTER //
// ./src/components/HandlePicker.js